
function getItem(items, value) {
    return items.reduce((previous, current) => {
        return (current.key === value)
            ? current
            : previous;
    }, null);
}

function getTitle(items, value) {
    const item = getItem(items, value);
    return item
        ? item.title
        : value;
}

module.exports = {
    getItem,
    getTitle
};
